var moment = require('momentjs')
var QuoteEditRoute = require('./quote-edit')
var reactDirtyRoute = require('../mixins/react-dirty-route')

module.exports = QuoteEditRoute.extend(reactDirtyRoute, {

    model: function(params) {
        var store = this.store
        var organization = this.modelFor('organization')
        var quote = store.createRecord('quote', {
            organization: organization,
            entryDate: moment(),
            state: 'open',
            templateId: organization.get('defaultTemplateId')
        })
        if (params.fromQuoteId) {
            return findQuote(store, params.fromQuoteId, organization.get('id'))
                .then(function(fromQuote) {
                    quote.setProperties(fromQuote.getProperties('type', 'contact', 'attContactPerson', 'dueDate', 'headerMessage', 'footerMessage', 'taxMode', 'currency', 'templateId', 'orderNo'))
                    return fromQuote.get('lines')
                })
                .then(function(lines) {
                    lines.forEach(function(line) {
                        var properties = line.getProperties('product', 'description', 'quantity', 'unitPrice', 'taxRate', 'currentTaxRate', 'discountText', 'discountMode', 'discountValue', 'priority')
                        properties.quote = quote
                        store.createRecord('quote-line', properties)
                    })
                    return quote
                })
        } else {
            quote.setProperties({
                type: params.newType || 'quote',
                currency: organization.get('baseCurrency')
            })
            store.createRecord('quote-line', {
                quote: quote,
                quantity: 1,
                priority: 1
            })
            return quote
        }
    },

    resetController: function(controller) {
        controller.set('fromQuoteId', null)
        controller.set('newContactId', null)
    },

    setupController: function(controller, model) {
        this._super(controller, model)
        controller.set('model', model)

        if (typeof model.resetClean === 'function') {
            model.resetClean()
        }

        if (model.get('lines')) {
            model.get('lines').forEach(function(line) {
                if (typeof line.resetClean === 'function') {
                    line.resetClean()
                }
            })
        }
        controller.set('deletedLines', [])

        var changeset = controller.get('attachmentsChangeset')
        if (changeset && typeof changeset.rollback === 'function') {
            changeset.rollback()
        }
    }
})

function findQuote(store, id, organizationId) {
    var quote = store.getById('quote', id)
    if (quote) {
        return Em.RSVP.resolve(quote)
    }
    var query = {
        id: id,
        organization: organizationId
    }
    return store.find('quote', query)
        .then(function(quotes) {
            if (quotes.get('length') === 0) {
                throw new Error('The quote was not found.')
            }
            return quotes.objectAt(0)
        })
}
